import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { useMemo } from 'react';

export function useIsMobileView() {
  const { isPhone, isPhoneLandscape } = useBreakpoints();

  const isMobile = useMemo(() => isPhone ?? isPhoneLandscape, [isPhone, isPhoneLandscape]);

  return isMobile;
}
